import { render, staticRenderFns } from "./createCode.vue?vue&type=template&id=34504a7d&scoped=true&"
import script from "./createCode.vue?vue&type=script&lang=js&"
export * from "./createCode.vue?vue&type=script&lang=js&"
import style0 from "./createCode.vue?vue&type=style&index=0&id=34504a7d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34504a7d",
  null
  
)

export default component.exports